import * as _ from 'lodash';
import { Component, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { GroupService } from '../settings/groups/shared/group.service';
import { HttpParams } from '@angular/common/http';
import { Group } from 'app/settings/groups/shared/group.model';
import { UserService } from 'app/users/shared/user.service';
import { UserFactory } from 'app/users/shared/user.factory';
import { User } from 'app/users/shared/user.model';
import { Role } from 'app/settings/roles/shared/role.model';
import { RoleService } from 'app/settings/roles/shared/role.service';
import { GlobalService } from 'app/shared/global.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html'
})

export class RegisterComponent implements OnInit {

    public returnUrl: string;
    public roles: Role[] = [];
    public groups: Group[] = [];
    public selectedRole: string;
    public selectedRoleFull: Role;
    public selectedGroup: string;
    public isRegistered: boolean;
    public loading = false;
    public childrenCount = 0;
    public childrenTemp: any[] = [];
    public dropdownGroups: any = [];
    public dropdownGroupsActive: Array<any> = [];

    public dropdownSettings = {
        singleSelection: true,
        text: this.translate.instant('select') + ' ...',
        enableSearchFilter: true,
        searchPlaceholderText: this.translate.instant('search'),
    };

    // tslint:disable-next-line:max-line-length
    public model: User = new User(false, false, false, false, '', null, '', '', 'student', [], {}, '', '', '', '', '', '', [], [], '', '', false, false, '', {}, [], 0, '', '', false, false);

    constructor(
        private authService: AuthService,
        private router: Router,
        private globalService: GlobalService,
        private roleService: RoleService,
        private groupService: GroupService,
        private userService: UserService,
        private titleService: Title,
        private route: ActivatedRoute,
        private translate: TranslateService) {
        /* localStorage.setItem('token', undefined);
        localStorage.setItem('isLoggedIn', 'false'); */
        localStorage.clear();
    }

    ngOnInit() {

        this.titleService.setTitle(this.translate.instant('register'));

        const params = new HttpParams();
        this.groupService.getRegisterAll(params).subscribe(groups => {
            /* this.groups = _.filter(groups, (item) => {
                return !item.hasOwnProperty('invisibleToMobile') || !item.invisibleToMobile;
            }); */
            this.groups = groups;
            this.dropdownGroups = groups.map((item) => {
                return { id: item.id, itemName: item.name };
            })
        });
        this.roleService.getRegisterAll(params).subscribe(roles => {
            this.roles = _.filter(roles, (item) => {
                return item.visibleToMobile;
            });
        });

        this.authService.logout();
        this.route.queryParams.subscribe(queryParams => {
            this.returnUrl = queryParams['returnUrl'] || '/';
        });
    }

    childrenCountChange(value) {
        // this.model.children = [];
        if (this.childrenCount < this.model.children.length) {
            this.childrenTemp = this.childrenTemp.slice(0, this.childrenCount)
        } else {
            for (let i = this.childrenTemp.length - 1; i < this.childrenCount - 1; i += 1) {
                this.childrenTemp.push({
                    firstname: '',
                    lastname: '',
                    group: '',
                });
            }
        }
    }

    dropdownGroupsSelect(value, child) {
        child.groups = {
            [value.id]: {
                id: value.id,
                name: value.itemName,
            }
        };
        console.log('child.groups', child.groups)
    }

    dropdownGroupsDeSelect(value) {
    }

    onRoleChanged(value, role) {
        this.selectedRoleFull = role;
        this.selectedRole = role.id;
        this.model.role = {
            id: role.id,
            name: role.name,
        };
    }

    onGroupChanged(value, group) {
        this.selectedGroup = group.id;
        this.model.groups = [{ id: group.id, name: group.name, active: false }];
    }

    onRegister() {

        const model = UserFactory.fromObject(this.model);

        this.loading = true;

        if (this.childrenTemp && this.childrenTemp.length) {
            model.groups = this.childrenTemp.map((item) => {
                return { id: item.group[0].id, name: item.group[0].itemName, active: false };
            })
            model.children = this.childrenTemp.map((item) => {
                return { firstname: item.firstname, lastname: item.lastname, groups: item.groups };
            })
        }
        this.userService.register(model).subscribe(result => {
            this.loading = false;
            if (result.success === false) {
                switch (result.message) {
                    case 'The email address is already in use by another account.':
                        result.message = 'Diese E-Mail Adresse ist bereits in Gebrauch.';
                        break;
                }
                console.error(result);
                this.globalService.handleError(new Error(result.message));
            } else {
                this.isRegistered = true;
            }
        });
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        }
        return true;
    }

    cancel() {
        this.router.navigate(['login'], { relativeTo: this.route.parent });
    }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts